var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHourglassHalf = function SvgHourglassHalf(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M15.54 2H4.77a.76.76 0 0 0-.77.75v.5a.76.76 0 0 0 .77.749 6.19 6.19 0 0 0 3.876 6.002 6.19 6.19 0 0 0-3.877 6 .76.76 0 0 0-.769.75v.5a.76.76 0 0 0 .77.749h10.77a.76.76 0 0 0 .768-.75v-.5a.76.76 0 0 0-.769-.749 6.19 6.19 0 0 0-3.874-6 6.19 6.19 0 0 0 3.874-6 .76.76 0 0 0 .77-.75v-.5a.74.74 0 0 0-.226-.53.78.78 0 0 0-.544-.22m-2.408 12H7.177a3.42 3.42 0 0 1 2.977-2.499 3.42 3.42 0 0 1 2.978 2.5m0-8H7.177a5.7 5.7 0 0 1-.357-2h6.667a5.7 5.7 0 0 1-.354 2z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHourglassHalf);
export default ForwardRef;